/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo } from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

import { skeletonConstants } from '../constants/skeletonConstants';

export const NetworkChartLoader = memo<IContentLoaderProps>(props => (
  <ContentLoader
    height={225}
    width={420}
    speed={2}
    backgroundColor={skeletonConstants.backgroundColor}
    foregroundColor={skeletonConstants.foregroundColor}
    {...props}
  >
    <circle cx="130" cy="90" r="16" />
    <circle cx="67" cy="156" r="12" />
    <circle cx="195" cy="155" r="12" />

    <rect x="75" y="153" width="5" height="80" transform="rotate(-45 45 50)" />
    <rect x="135" y="35" width="5" height="80" transform="rotate(45 55 50)" />

    <circle cx="285" cy="59" r="5" />
    <rect x="300" y="51" rx="4" ry="4" width="85" height="15" />

    <circle cx="285" cy="83" r="5" />
    <rect x="300" y="75" rx="4" ry="4" width="85" height="15" />
  </ContentLoader>
));
